module.exports = __webpack_public_path__ + "media/images/sp/stores/sola/instagram/sola_sns_02-64f06704600b33a9d983aa84529a144f.jpg";